import { defineComponent as _defineComponent } from 'vue'
import CardInformacoesGerais from './components/consulta/CardInformacoesGerais.vue';
import { ConsultaLegislacaoStore } from '@/views/legislacao/store/ConsultaLegislacaoStore';
import { mdiArrowLeft } from '@mdi/js';
import router from '@/router';

import SeletorOpcoesImpressão from '@/views/components/SeletorOpcoesImpressão.vue';
import HeaderCustom from '../components/HeaderCustom.vue';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import IconTextoNorma from '@/views/components/icons/IconTextoNorma.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LegislacaoSelecionada',
  setup(__props) {

const store = ConsultaLegislacaoStore();

const itensImpressao = [
  {
    text: 'Simplificado',
    value: 'S',
    icone: IconPaginaSimplificada,
  },
  {
    text: 'Detalhado',
    value: 'D',
    icone: IconPaginaDetalhada,
  },
  {
    text: 'Texto da norma',
    value: 'T',
    icone: IconTextoNorma,
  },
];

return { __sfc: true,store, itensImpressao, CardInformacoesGerais, mdiArrowLeft, router, SeletorOpcoesImpressão, HeaderCustom }
}

})